import { type ReactElement } from "react";
import { type SocialPath } from "@/models";
import { useLanguage } from "@/context";
import { t } from "@/data";

interface SocialProps {
  data: readonly SocialPath[];
}

export const Social = ({ data }: SocialProps): ReactElement => {
  const { lang } = useLanguage();

  return (
    <nav className="social" aria-label={t(lang, "socialLinks")}>
      {data.map(({ path, icon, title }, index) => (
        <a key={index} href={path} target="_blank" rel="noopener noreferrer" aria-label={title}>
          {icon}
        </a>
      ))}
    </nav>
  );
};
